import { assign } from 'xstate';

import { FlowConsumerContextEnergy } from '../../context';
import { energyTypeIncludes } from '../helpers';
import { EnergyType } from '../types';

const resetValues = (energyType: EnergyType): FlowConsumerContextEnergy => {
  const data: FlowConsumerContextEnergy = {};

  data.discountCode = undefined;

  if (!energyTypeIncludes(energyType, EnergyType.Electricity)) {
    data.hasDoubleMeter = undefined;

    data.usageElectricityHigh = undefined;
    data.usageElectricityLow = undefined;

    data.hasSolarPanels = undefined;
    data.solarPanelsOutput = undefined;
  }

  if (!energyTypeIncludes(energyType, EnergyType.Gas)) {
    data.usageGas = undefined;
  }

  if (!energyTypeIncludes(energyType, EnergyType.Warmth)) {
    data.usageWarmth = undefined;
  }

  if (!energyTypeIncludes(energyType, EnergyType.TapWater)) {
    data.usageWater = undefined;
  }

  return data;
};

export const resetUsageValues = assign(({ context }) => {
  const energyType = context.energyType ?? EnergyType.Electricity;

  const values = {
    ...context,
    ...resetValues(energyType),
  };

  // since certain "energyTypes" and "offerTypes" don't have duration
  // variations  such is "...1Year", "...3Month" and etc. we should
  // assign "default" value for the "discountCode" property cuz we are
  // most likely going to  skip the "Offer" step since it is no use
  // to show a single offer...

  // when "energyType is equal to "Warmth" or "WarmthAndTapWater" we
  // should override the "hasResidencePurpose" property since we can
  // only deliver "warmth" related products to a "residential" addresses
  if (
    energyType === EnergyType.Warmth ||
    energyType === EnergyType.WarmthAndTapWater ||
    energyType === EnergyType.GeothermalHeating
  ) {
    values.discountCode = 'unknown';
    values.hasResidencePurpose = true;
  }

  return values;
});
